import {
    Backdrop,
    CircularProgress,
    Theme,
    makeStyles,
} from '@material-ui/core'
import React, { FC } from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: theme.palette.common.white,
    },
}))

const LoadingBackdrop: FC<{ isVisible: boolean }> = ({ isVisible }) => {
    const classes = useStyles()

    return (
        <Backdrop className={classes.backdrop} open={isVisible}>
            <CircularProgress color="inherit" />
        </Backdrop>
    )
}

export default LoadingBackdrop
